import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "calendar-wrapper" }
const _hoisted_2 = { class: "icons" }
const _hoisted_3 = { class: "current-date" }
const _hoisted_4 = { class: "calendar" }
const _hoisted_5 = { class: "days" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          id: "prev",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeMonth(-1)))
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "ri-arrow-left-s-line" }, null, -1)
        ]))]),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.currentDate), 1),
        _createElementVNode("span", {
          id: "next",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeMonth(1)))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("i", { class: "ri-arrow-right-s-line" }, null, -1)
        ]))])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[4] || (_cache[4] = _createElementVNode("ul", { class: "weeks" }, [
        _createElementVNode("li", null, "Sun"),
        _createElementVNode("li", null, "Mon"),
        _createElementVNode("li", null, "Tue"),
        _createElementVNode("li", null, "Wed"),
        _createElementVNode("li", null, "Thu"),
        _createElementVNode("li", null, "Fri"),
        _createElementVNode("li", null, "Sat")
      ], -1)),
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calendarDays, (day, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: _normalizeClass([day.class])
          }, _toDisplayString(day.date), 3))
        }), 128))
      ])
    ])
  ]))
}